import Types from "./actionTypes";
import { combineReducers } from "redux";
import Language from "./Language";

import BuildingReducer from "./BuildingReducer";

const initialSections = {};
//   // eww
//   // should I make the initial state an empty object and then create an initializing action?
//   Welcome: {
//     expanded: true,
//   },
// }
const sectionsReducer = (sections, action) => {
  if(!sections) {
    sections = initialSections;
  }

  switch (action.type) {
    case Types.EXPAND: {
      return {
        //...sections,
        [action.id]: {
          expanded: true,
        }
      }
    }
    case Types.COLLAPSE: {
      return {
        //...sections,
        [action.id]: {
          expanded: false,
        }
      }
    }
    default:
      return sections;
  }
};

const initialLang = Language.ENGLISH;
const langReducer = (lang, action) => {
  //console.log(action);

  if(!lang) {
    lang = initialLang;
  }

  switch (action.type) {
    case Types.CHANGE_LANG: {
      Language.validate(action.newLang);

      return action.newLang;
    }
    default:
      return lang;
  }
};

const initialCurrentBuilding = ""; // hmmm, not sure what to do here...
const currentBuildingReducer = (currentBuilding, action) => {
  if(!currentBuilding) {
    currentBuilding = initialCurrentBuilding;
  }

  switch(action.type) {
    case Types.ADD_BUILDING: {
      return action.buildingId;
    }
    case Types.DELETE_BUILDING: {
      return action.buildingId === currentBuilding ? initialCurrentBuilding : currentBuilding; // Or, should I set to the prevous one if it exists...
    }
    case Types.SET_CURRENT_BUILDING: {
      return action.buildingId;
    }
    default:
      return currentBuilding;
  }
};

const initialCurrentReportBuilding = ""; // hmmm, not sure what to do here...
const currentBuildingReportReducer = (currentReportBuilding, action) => {
  if(!currentReportBuilding) {
    currentReportBuilding = initialCurrentReportBuilding;
  }

  switch(action.type) {
    case Types.ADD_BUILDING: {
      return action.buildingId;
    }
    case Types.DELETE_BUILDING: {
      return action.buildingId === currentReportBuilding ? initialCurrentBuilding : currentReportBuilding; // Or, should I set to the prevous one if it exists...
    }
    case Types.SET_CURRENT_BUILDING: {
      return action.buildingId;
    }
    case Types.SET_CURRENT_REPORT_BUILDING: {
      return action.buildingId;
    }
    default:
      return currentReportBuilding;
  }
};

const initialCurrentFacade = "";
const currentFacadeReducer = (currentFacade, action) => {
  if(!currentFacade) {
    currentFacade = initialCurrentFacade;
  }

  switch(action.type) {
    case Types.ADD_FACADE: {
      return action.facadeId;
    }
    case Types.DELETE_FACADE: {
      return action.facadeId === currentFacade ? initialCurrentFacade : currentFacade; // Or, should I set to the prevous one if it exists...
    }
    case Types.SET_CURRENT_FACADE: {
      return action.facadeId;
    }
    case Types.ADD_BUILDING: {
      return initialCurrentFacade;
    }
    case Types.DELETE_BUILDING: {
      return initialCurrentFacade;
    }
    case Types.SET_CURRENT_BUILDING: {
      return initialCurrentFacade;
    }
    default:
      return currentFacade;
  }
};

export default combineReducers({
  version: (state, action) => "1.0.0",
  sections: sectionsReducer,
  lang: langReducer,
  buildings: BuildingReducer, // contains (data and) facades, which contain data
  currentBuildingId: currentBuildingReducer,
  currentFacadeId: currentFacadeReducer,
  currentReportBuildingId: currentBuildingReportReducer,
});


// WEBPACK FOOTER //
// ./src/modules/reducers.js